import { atom } from 'jotai';
import * as poiState from './atoms';
export const cancelPOIAdd = atom(
  null,
  (get, set) => {
    set(poiState.blisterToAdd, undefined);
    set(poiState.editPointOfInterest, { state: 'Inactive', pointOfInterest: undefined, isManuallyCreated: undefined, poiSphericalId: undefined });
  }
);
